import styled from "@emotion/styled";
import { BREAKPOINTS } from "../../utils/consts";

const GridItem = styled.div((props) => {
  let style = {
    gridColumn: "span " + (props.desktopQty || 12),
    ...props.style,
  };

  style[`@media (max-width: ${BREAKPOINTS.TABLET_PORTRAIT}px)`] = {
    gridColumn: "span " + (props.tabletQty || props.desktopQty || 12),
  };

  style[`@media (max-width: ${BREAKPOINTS.PHONE}px)`] = {
    gridColumn:
      "span " + (props.phoneQty || props.tabletQty || props.desktopQty || 12),
  };

  if (props.className === "hide") {
    style["display"] = "none";
  }

  return style;
});

export default GridItem;
